import {
  Components,
  inputLabelClasses,
  outlinedInputClasses,
} from '@mui/material';
import type { WatchdutyTheme } from './MuiChip';

export const getMuiTextField = (
  theme: WatchdutyTheme,
): Components['MuiTextField'] => ({
  defaultProps: {
    variant: 'outlined',
  },
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: 'filled' },
          style: {
            // MUI doesn't allow custom variants for TextFields, so we use the
            // className as a variant: https://medium.com/@victorgonz96/create-material-ui-textfield-variants-2616b673cce0
            '&&&.watchduty-filled-nolabel': {
              '.MuiInputBase-root': {
                borderRadius: 8,
                // Use theme.vars (CSS variable reference) so the color tracks the active
                // color scheme.
                backgroundColor: theme.vars.palette.background.secondary,
              },
              input: {
                paddingTop: '4px',
                paddingBottom: '4px',
              },
              '.MuiInputAdornment-root': {
                marginTop: '0',
              },
              '& :before, & :after, &:hover :before, &:hover :after': {
                borderBottom: 'none',
              },
              '& .MuiInputBase-input::placeholder': {
                fontSize: theme.typography.body1.fontSize,
                color: theme.vars.palette.text.disabled,
                // Override the browser's default placeholder opacity so the color renders as defined
                opacity: 1,
              },
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'primary' },
          style: {
            [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused}:not(.${outlinedInputClasses.error}) .${outlinedInputClasses.notchedOutline}`]:
              {
                borderColor: theme.palette.brand[500],
              },
            [`& .${inputLabelClasses.root}.${inputLabelClasses.focused}:not(.${inputLabelClasses.error})`]:
              {
                color: theme.palette.brand[500],
              },
          },
        },
      ],
    },
  },
});
